import {SxType} from "@baseTypes/sx/sxTypes";

export const sx:SxType = {
    root:{
        padding:'10px',
        display:'flex',
        gap:'10px',
        flexDirection:'column'
    }
}
